//conditional rendering / layout logic
export const THREE_COLUMN_PATHS = [
  '/home',
  '/plans',
  '/settings',
  '/consult/:consultId/treatment-plan',
  '/messaging',
];

export const HIDE_ACCOUNT_TITLE_PATHS = ['/consult/:consultId/results'];

export const HIDE_TAB_NAV_PATHS = [
  '/settings/account',
  '/settings/:accountOrPatientId',
  '/messaging/:channelId',
];

export const EXLCUDED_PROVIDER_TYPES = [
  'massage',
  'acupuncturist',
  'dentist',
  'dental',
  'chiropractor',
  'chiropractic',
  'social worker',
  'pharmacist',
];

export const PatientChatChannelType = 'patient-chat';

export const FIRST_NAME_LIMIT = 60;
export const LAST_NAME_LIMIT = 120;

// regex patterns
export const REGEX_PATTERNS = {
  firstCharacterIsLetter: new RegExp(/^[A-Za-z][A-Za-z0-9\s]*$/),
  phoneNumberValidation: new RegExp(
    /^\+?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
  ),
};

export const EmailRegex =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const BendHelpLine = {
  rawNum: '18005160975',
  formattedNum: '1-800-516-0975',
};
